<template>
  <VuePerfectScrollbar class="e-content__inner e-content__inner--wide">
    <div class="e-content__scroll">
      <the-chat />
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import Loading from 'atoms/Loading/Loading'
import TheChat from 'organisms/TheChat/TheChat'
import { mapGetters } from 'vuex'

export default {
  components: {
    // Loading,
    VuePerfectScrollbar,
    TheChat
  },

  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters(['chatIsDisabled'])
  },
  created() {
    if (this.chatIsDisabled) {
      this.$router.push({ name: 'dialogs' })
    }
  },
  watch: {
    chatIsDisabled(newVal) {
      if (newVal) {
        this.$router.push({ name: 'dialogs' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '_assets/LiveChat';
</style>
